import styled from 'styled-components';
import { mq, px2rem, getSpace } from '../../../stylesheets/tools';

const BACKGROUND_COLOR = '#5a9af6';
const ACCENT_COLOR = '#83c1f1';

const StyledBanner = styled.div`
  position: relative;
  width: 100%;
  z-index: 2;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  background: ${BACKGROUND_COLOR};

  overflow: hidden;
  padding: 0 ${px2rem('34px')};

  ${mq('m')} {
    grid-template-columns: 2fr 1fr;
    padding: 0 ${px2rem('46px')};
  }
  ${mq('xl')} {
    padding: 0 ${px2rem('52px')};
  }

  .sponsor-banner__sponsor-text,
  .sponsor-banner__link-text {
    p {
      margin: 0;
    }
  }

  .sponsor-banner__sponsor-text {
    width: 100%;
    padding: ${getSpace('xxxs')} 0;
    * {
      font-size: 14px;
    }

    ${mq('m')} {
      padding: ${getSpace('xxs')};
    }
  }

  .sponsor-banner__link-text {
    position: relative;
    background: ${ACCENT_COLOR};
    padding: ${getSpace('xxxs')} 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: flex;
    gap: ${getSpace('xxs')};
    align-items: center;

    /* background extension right */
    &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: -100vw;
      width: 200vw;
      background: ${ACCENT_COLOR};
      z-index: -1;
    }

    ${mq('m')} {
      svg {
        margin-left: ${getSpace('xs')};
      }
      padding: ${getSpace('xxs')};
      &::after {
        left: 0;
      }
    }
  }
`;

export default StyledBanner;
